import styles from "./ride-list-item.module.less";
import UiPicture from "@rnb/ui-picture";
import Label from "components/block-elements/label/label";
import borderPatterns from "styles/theming/border-patterns.module.less";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import QueueTimeDisplay from "components/block-elements/queue-time-display/queue-time-display";
import { extract, Icon } from "@parksandresorts/core";
import { getStandardCardPicture } from "components/helpers/picture-helper";

const RideListItem = (props) => {
  const {
    borderPattern,
    componentTheme,
    couponCount,
    couponText,
    minimumHeight,
    title,
    label,
    extraClass,
    ageRequirement,
    noHeightRequirement,
    mobileCompactList,
    separateTickets,
    attractionQueueTime,
    imageInList,
  } = props;

  const linkUrl = extract(props, "pageLink.slug");

  const noHeightRequirementLabel = SiteConfigurationStore.getLabel("NO_HEIGHT_LIMIT");
  const atLeastLabel = SiteConfigurationStore.getLabel("AT_LEAST");
  const couponsLabel = SiteConfigurationStore.getLabel("COUPONS");
  const separateTicketsLabel = SiteConfigurationStore.getLabel("SEPARATE_TICKET");

  return (
    <div className={componentTheme ? `component-theme-${componentTheme}` : ""}>
      <LinkWrapper className={styles.link} url={linkUrl}>
        <div
          className={[
            mobileCompactList ? styles.mobileCompactList : "",
            borderPatterns[borderPattern + "_card"],
            mobileCompactList ? styles.mobileCompact : "",
            styles.wrapper,
            attractionQueueTime ? styles.displayQueueTimes : "",
            extraClass ? extraClass : "",
          ].join(" ")}
        >
          <div className={styles.labelWrapper}>{label && <Label extraClass={styles.label} title={label} />}</div>
          <div className={styles.imageWrapper}>
            {imageInList && (
              <UiPicture
                {...getStandardCardPicture(imageInList, `${props.contentful_id}_${props.id}`)}
                classNamePicture={styles.picture}
              />
            )}
          </div>
          <div className={styles.textWrapper}>
            {title && <h5 className={styles.headline}>{title}</h5>}
            {(ageRequirement || noHeightRequirement || minimumHeight) && (
              <div className={[styles.propertyRow, styles.minHeight].join(" ")}>
                <span className={["icon-length", styles.icon].join(" ")} />
                <span className={[styles.propertyValue, "body-s"].join(" ")}>
                  {ageRequirement ? (
                    ageRequirement
                  ) : noHeightRequirement ? (
                    noHeightRequirementLabel
                  ) : (
                    <>
                      {atLeastLabel && <span className={styles.hiddenMobile}>{`${atLeastLabel} `}</span>}
                      {minimumHeight}
                    </>
                  )}
                </span>
              </div>
            )}
            {(separateTickets || couponText || couponCount) && (
              <div className={[styles.propertyRow, styles.couponCount].join(" ")}>
                <Icon name="ticket" className={styles.icon} size="s" />
                <span className={[styles.propertyValue, "body-s"].join(" ")}>
                  {separateTickets ? (
                    <span className={styles.propertyValue}>{separateTicketsLabel}</span>
                  ) : couponText ? (
                    <>
                      <span>{`${couponText}`}</span>
                    </>
                  ) : (
                    <>
                      <span>{couponCount}</span>
                      {couponsLabel && <span>{` ${couponsLabel}`}</span>}
                    </>
                  )}
                </span>
              </div>
            )}
            {attractionQueueTime && (
              <div className={[styles.propertyRow, styles.queueTime, "fade-in"].join(" ")}>
                <Icon name="clock" className={styles.icon} size="s" />
                <span className={[styles.propertyValue, "body-s"].join(" ")}>
                  <QueueTimeDisplay queueTime={attractionQueueTime} />
                </span>
              </div>
            )}
          </div>
        </div>
      </LinkWrapper>
    </div>
  );
};
export default RideListItem;
